<template>
    <div class="report_container">
        <header class="report_header">
            <div>欧欧AI视力报告</div>
            <div>基于孩子的基础视力数据及统计学参数，运用AI算法，给出孩子未来视力发展预测报告。</div>
        </header>
        <main class="report_main">
            <section class="report_form">
                <div>补全下列信息，一键生成孩子专属AI视力报告。</div>
                <div class="formbox">
                    <div class="parent">
                        <div>家长信息</div>
                        <div>
                            <div class="required">家长手机号</div>
                            <input class="ipt1" type="text" v-model="formData.parent.phone">
                        </div>
                    </div>
                    <div class="student">
                        <div>学生：</div>
                        <input style="background-color:#ffffff;text-indent:0;" class="ipt1" type="text" v-model="formData.student.name" onfocus="this.blur()">
                    </div>
                    <div class="item">
                        <div class="required">年龄</div>
                        <input class="ipt1" type="text" v-model="formData.student.age" onfocus="this.blur()" @click.prevent="onIpt('student','age')">
                    </div>
                    <div class="item">
                        <div class="required">性别</div>
                        <input class="ipt1" type="text" v-model="formData.student.gender" onfocus="this.blur()" @click.prevent="onIpt('student','gender')">
                    </div>
                    <div class="item">
                        <div class="required">身高</div>
                        <input class="ipt1" type="text" v-model="formData.student.stature" onfocus="this.blur()" @click.prevent="onIpt('student','stature')">
                    </div>
                    <div class="item">
                        <div class="required">体重</div>
                        <input class="ipt1" type="text" v-model="formData.student.weight" onfocus="this.blur()" @click.prevent="onIpt('student','weight')">
                    </div>
                    <div class="item">
                        <div class="required">父母带镜人数</div>
                        <input class="ipt1" type="text" v-model="formData.student.withGlassesNum" onfocus="this.blur()" @click.prevent="onIpt('student','withGlassesNum')">
                    </div>
                    <div class="item">
                        <div class="required">父亲身高</div>
                        <input class="ipt1" type="text" v-model="formData.parent.father.stature" onfocus="this.blur()" @click.prevent="onIpt('father','stature')">
                    </div>
                    <div class="item">
                        <div class="required">父亲体重</div>
                        <input class="ipt1" type="text" v-model="formData.parent.father.weight" onfocus="this.blur()" @click.prevent="onIpt('father','weight')">
                    </div>
                    <div class="item">
                        <div class="required">母亲身高</div>
                        <input class="ipt1" type="text" v-model="formData.parent.mother.stature" onfocus="this.blur()" @click.prevent="onIpt('mother','stature')">
                    </div>
                    <div class="item">
                        <div class="required">母亲体重</div>
                        <input class="ipt1" type="text" v-model="formData.parent.mother.weight" onfocus="this.blur()" @click.prevent="onIpt('mother','weight')">
                    </div>
                </div>
            </section>
        </main>
        <footer class="report_footer">
            <van-button type="primary" color="#3BD3C1" @click="onSubmit">提交</van-button>
        </footer>
        <van-action-sheet style="max-height:40%" duration="0.3" v-model="show" :actions="actions" @select="onSelect" @click-overlay="onClose" :description="`请选择${option}`"/>
        <div class="go_list" v-if="loading">
            <img src="../../assets/img/report/go_list.png" alt="">
            <div>报告生成中，请您耐心等待。</div>
        </div>
    </div>
</template>

<script>
import { submitReportFormApi } from "../../api/report";
import { getName , getStudentId} from "@/utils/auth.js"
export default {
  data() {
    return {
      show: false,
      loading:false,
      actions: [],
      who: "",
      option: "",
      formData: {
        parent: {
          // phone:"1583525",
          father: {
            // stature:"1",
            // weight: "2"
          },
          mother: {
            // stature:"3",
            // weight: "4"
          }
        },
        student: {
          name: getName() || ""
          // age:"222",
          // gender:"333",
          // stature:"444",
          // weight: "555",
          // withGlassesNum: "666",
        }
      },
      studentId: getStudentId() || ""
    };
  },
  mounted() {
    console.log(5)
  },
  methods: {
    //选中项
    onSelect(item) {
      console.log(item)
      if (this.who == "student") {
        if (this.option == "年龄") {
          this.formData.student.age = item.name;
        } else if (this.option == "性别") {
          this.formData.student.gender = item.name;
        } else if (this.option == "父母戴镜人数") {
          this.formData.student.withGlassesNum = item.name;
        } else if (this.option == "身高") {
          this.formData.student.stature = item.name;
        } else if (this.option == "体重") {
          this.formData.student.weight = item.name;
        }
      } else if (this.who == "father") {
        if (this.option == "身高") {
          this.formData.parent.father.stature = item.name;
        } else if (this.option == "体重") {
          this.formData.parent.father.weight = item.name;
        }
      } else if (this.who == "mother") {
        if (this.option == "身高") {
          this.formData.parent.mother.stature = item.name;
        } else if (this.option == "体重") {
          this.formData.parent.mother.weight = item.name;
        }
      }
      this.actions = []
      this.show = false;
    },
    // ipt点击
    onIpt(who, option) {
      this.show = true;
      this.who = who;
      if (option == "age") {
        this.option = "年龄";
        let arr = [];
        for(let i = 6; i <= 15; i++) {
          let obj = {
            name : i + "岁"
          }
          arr.push(obj)
        }
        this.actions = arr;
      }
      if (option == "gender") {
        this.option = "性别";
        this.actions = [{ name: "男" }, { name: "女" }];
      }
      if (option == "withGlassesNum") {
        this.option = "父母戴镜人数";
        this.actions = [{ name:"0" },{ name: "1" }, { name: "2" }];
      }
      if (who == 'student' && option == "stature") {
        this.option = "身高";
        let arr = [];
        for(let i = 80; i <= 200; i++) {
          let obj = {
            name : i + "cm"
          }
          arr.push(obj)
        }
        this.actions = arr;
      }
      if (who == 'student' && option == "weight") {
        this.option = "体重";
        let arr = [];
        for(let i = 10; i <= 100; i++) {
          let obj = {
            name : i + "kg"
          }
          arr.push(obj)
        }
        this.actions = arr;
      }
      if ((who == 'father' || who == 'mother') && option == "stature") {
        this.option = "身高";
        let arr = [];
        for(let i = 140; i <= 200; i++) {
          let obj = {
            name : i + "cm"
          }
          arr.push(obj)
        }
        this.actions = arr;
      }
      if ((who == 'father' || who == 'mother') && option == "weight") {
        this.option = "体重";
        let arr = [];
        for(let i = 40; i <= 150; i++) {
          let obj = {
            name : i + "kg"
          }
          arr.push(obj)
        }
        this.actions = arr;
      }
    },
    // 提交
    onSubmit() {
      if (!this.formData.parent.phone) {
        this.$toast.fail("请填写家长手机号");
        return;
      }
      if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.formData.parent.phone)) {
        this.$toast.fail("手机号格式有误");
        return;
      }
      if (!this.formData.student.age) {
        this.$toast.fail("请选择学生年龄");
        return;
      }
      if (!this.formData.student.gender) {
        this.$toast.fail("请选择学生性别");
        return;
      }
      if (!this.formData.student.stature) {
        this.$toast.fail("请选择学生身高");
        return;
      }
      if (!this.formData.student.weight) {
        this.$toast.fail("请选择学生体重");
        return;
      }
      if (!this.formData.student.withGlassesNum) {
        this.$toast.fail("请选择家长戴镜人数");
        return;
      }
      if (!this.formData.parent.father.stature) {
        this.$toast.fail("请选择父亲身高");
        return;
      }
      if (!this.formData.parent.father.weight) {
        this.$toast.fail("请选择父亲体重");
        return;
      }
      if (!this.formData.parent.mother.stature) {
        this.$toast.fail("请选择母亲身高");
        return;
      }
      if (!this.formData.parent.mother.weight) {
        this.$toast.fail("请选择母亲体重");
        return;
      }

      this.loading = true;
      if(this.formData.student.gender == "男") {
          this.formData.student.gender = 1
      } 
      if(this.formData.student.gender == "女") {
          this.formData.student.gender = 2
      } 
      submitReportFormApi({
          studentId:this.studentId,
          phone:this.formData.parent.phone,
          age: parseInt(this.formData.student.age),
          sex: this.formData.student.gender,
          height: parseInt(this.formData.student.stature),
          weight: parseInt(this.formData.student.weight),
          parentGlasses: this.formData.student.withGlassesNum,
          fatherHeight: parseInt(this.formData.parent.father.stature),
          fatherWeight: parseInt(this.formData.parent.father.weight),
          motherHeight: parseInt(this.formData.parent.mother.stature),
          motherWeight: parseInt(this.formData.parent.mother.weight)
      }).then(res=>{
            console.log(res)
            this.loading = false
            this.$router.push({ name: "ReportList" });
      }).catch(err=>{
            console.log(err);
            return Promise.reject(err);
      })
      
    },
    onClose() {
      console.log(this.actions)
      this.actions = []
    }
  }
};
</script>

<style scoped>
.report_container {
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}

.report_header {
  height: 0.7rem;
  padding: 0.4rem 0.3rem 0.55rem;
  border-radius: 0 0 0.2rem 0.2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: #3bd3c1;
}

.report_header > div:first-child {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.24rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}

.report_header > div:nth-child(2) {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 400;
}

.report_main {
  position: absolute;
  top: 1.28rem;
  width: 100%;
}

.report_form {
  width: calc(100vw - 0.2rem);
  padding-bottom: 0.2rem;
  background-color: #ffffff;
  margin: 0 auto 1.08rem;
  border-radius: 0.2rem;
}

.report_form > div:first-child {
  height: 0.42rem;
  padding-left: 0.2rem;
  border-bottom: 0.01rem solid #f5f5f5;
  display: flex;
  align-items: center;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #3bd3c1;
  letter-spacing: 0;
  font-weight: 400;
}

.formbox {
  padding-left: 0.2rem;
}

.parent {
  height: 0.84rem;
  border-bottom: 0.01rem solid #f5f5f5;
}

.parent > div:first-child {
  height: 0.36rem;
  display: flex;
  align-items: center;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #8a8a8a;
  letter-spacing: 0;
  font-weight: 400;
}

.parent > div:nth-child(2) {
  margin-right: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.parent > div:nth-child(2) > div {
  color: #505050;
  min-width: 1rem;
  flex: 1;
}

.parent > div:nth-child(2) > input {
  flex: 1;
}

.ipt1 {
  max-width: 1.8rem;
  flex: 1;
  height: 0.36rem;
  text-indent: 0.1rem;
  border: 0;
  padding: 0;
  background-color: #e0edeb;
  border-radius: 0.04rem;
}

.student {
  height: 0.7rem;
  margin-right: 0.2rem;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.student > div:first-child {
  color: #505050;
  min-width: 1.1rem;
  flex: 1;
}

.student > div:last-child {
  flex: 1;
}

.item {
  height: 0.36rem;
  margin-bottom: 0.2rem;
  margin-right: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item > div:first-child {
  color: #505050;
  min-width: 1rem;
  flex: 1;
}

.required::after {
  content: "*";
  margin-left: 0.04rem;
  color: #3bd3c1;
  font-size: 0.14rem;
}

.report_footer {
  width: 100vw;
  height: 0.88rem;
  box-sizing: border-box;
  padding: 0 0.3rem;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.report_footer >>> .van-button {
  width: 100%;
  height: 0.48rem;
  border-radius: 0.1rem;
  font-family: SourceHanSansCN-Medium;
  font-size: 0.16rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}

.go_list {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.go_list > img {
    width: 0.9rem;
    height: 0.9rem;
    margin-top: 1.12rem;
}

.go_list > div {
    font-family: SourceHanSansCN-Normal;
    font-size: 0.16rem;
    color: #707070;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    line-height: 0.16rem;
}
</style>